import Flex from '@Components/Bases/Flex';
import { Box, CircularProgress, Typography } from '@mui/material';
import { IRelateMasterDataFormValues } from '../../GoalAndOperationalPlansFormProvider/types';
import { INFO_CATEGORY_MASTER_DATA } from 'src/Enum/MasterData';
import { useGetInfoCategoryMasterData } from '@Domains/MasterData';
import { CATEGORY_TITLES, OTHER_TARGETS_ID } from '@Domains/TargetRelated';
import { useFormContext } from 'react-hook-form';
import {
  mapTargetByGroupsToUIDisplay,
  targetDetailsMapping,
} from './RelatedTargetModal/utils';

type TargetDetailProps = {
  planIndex: number;
};

export type RelateTargetsWithCategory = IRelateMasterDataFormValues & {
  infoCategory: string;
  sequence: number;
};

const TargetDetails = ({ planIndex }: TargetDetailProps) => {
  const { watch } = useFormContext();
  const selectedTargets: IRelateMasterDataFormValues[] = watch(
    `companyValueIncreasePlans.valueUpPlans.${planIndex}.relateGoals`
  );

  const [{ data, loading }] = useGetInfoCategoryMasterData([
    INFO_CATEGORY_MASTER_DATA.GOAL_BUSINESS_PLAN,
    INFO_CATEGORY_MASTER_DATA.GOAL_COST_PLAN,
    INFO_CATEGORY_MASTER_DATA.GOAL_INVESTMENT_PLAN,
    INFO_CATEGORY_MASTER_DATA.GOAL_DEBT_PLAN,
  ]);

  const targetWithGroups = mapTargetByGroupsToUIDisplay(
    targetDetailsMapping(selectedTargets, data)
  );

  if (loading) {
    return <CircularProgress />;
  }

  return (
    <Flex gap={2}>
      <Box>
        {targetWithGroups?.map((group, index) => (
          <Flex key={index} width={1} gap={3} mb={2}>
            <Box flex={1}>
              <Typography sx={{ textDecoration: 'underline' }}>
                {CATEGORY_TITLES[group.infoCategory]?.titleTh}
              </Typography>
              {group.data.map((target) => {
                const isOther = Object.values(OTHER_TARGETS_ID).includes(
                  target.infoCategoryMasterDataId ?? 0
                );

                if (!isOther && !target.nameTh) return null;

                return (
                  <Typography
                    key={target.infoCategoryMasterDataId}
                    component={'li'}
                  >
                    {`${isOther ? 'อื่น ๆ : ' : ''}${target.nameTh}`}
                  </Typography>
                );
              })}
            </Box>
            <Box flex={1}>
              <Typography sx={{ textDecoration: 'underline' }}>
                {CATEGORY_TITLES[group.infoCategory]?.titleEn}
              </Typography>
              {group.data.map((target) => {
                const isOther = Object.values(OTHER_TARGETS_ID).includes(
                  target.infoCategoryMasterDataId ?? 0
                );

                if (!isOther && !target.nameTh) return null;

                return (
                  <Typography
                    key={target.infoCategoryMasterDataId}
                    component={'li'}
                  >
                    {`${isOther ? 'Other : ' : ''}${target.nameEn}`}
                  </Typography>
                );
              })}
            </Box>
          </Flex>
        ))}
      </Box>
    </Flex>
  );
};

export default TargetDetails;
